import { UploadFileReqDto } from '@app/entities/files/interfaces/upload-file.req.dto';
import { UpdateProfileReqDto } from '@app/entities/users/interfaces/update-profile.req.dto';

export class LoadProfile {
  static readonly type = '[Profile] Load profile';
  constructor() {}
}

export class UpdateProfile {
  static readonly type = '[Profile] Update profile';
  constructor(public data: UpdateProfileReqDto) {}
}

export class UploadAvatar {
  static readonly type = '[Profile] Upload avatar';
  constructor(public data: UploadFileReqDto) {}
}
